import styled from "styled-components"
import { motion } from "framer-motion"

export const TableContainer = styled(motion.div)`
  background: #2A2B2E;
  border-radius: 8px;
  overflow: hidden;
  margin: 20px 0;
`

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const TableTitle = styled.h2`
  font-size: 1.2rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
`

export const AddButton = styled(motion.button)`
  background: #4A88F3;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: #3B78E0;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 10px;
  }
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;
  color: #fff;
`

export const TableHead = styled.thead`
  @media (max-width: 768px) {
    display: none;
  }
`

export const TableBody = styled.tbody`
  @media (max-width: 768px) {
    display: block;
  }
`

export const TableRow = styled(motion.tr)`
  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
    overflow: hidden;
  @media (max-width: 768px) {
    display: block;
    margin-bottom: 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 12px;
  }
`

export const TableCell = styled.td`
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  max-width: 200px; // Limitar el ancho máximo
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    display: flex;
    padding: 8px 0;
    border: none;
    max-width: 100%; // Ancho completo en móviles
    white-space: normal; // Permitir múltiples líneas en móviles

    &:before {
      content: attr(data-label);
      font-weight: 600;
      width: 120px;
      min-width: 120px;
      padding-right: 12px;
    }
  }
`

export const ResponsiveTableWrapper = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`

export const Tooltip = styled.span`
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;

  &:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }
`

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`

